import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisVertical } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import { fetchExamPreferenceList } from '../../../redux/slices/accountInfoSlice/actions';
import styles from './MyExam.module.scss';
import examPrefstyles from '../../Auth/Auth.module.scss';
import RippleButton from '../../HomePage/HeroSection/RippleButton';
import NotFoundContainer from '../../../container/NotFound';
import ExamPreferenceComponent from '../../Auth/ExamPreference';

function MyExam() {
  const dispatch = useDispatch();
  const [showID, setShowID] = React.useState(0);
  const [examPrefModal, setExamPrefModal] = React.useState(false);
  const { showLogin, selectedExamPreference, isAuthenticated } = useSelector((state) => ({
    showLogin: state?.auth?.showLogin,
    selectedExamPreference: state?.accountInfo?.userExamPreferenceDetails,
    isAuthenticated: state.auth.isAuthenticated,
  }));
  const { name, categoryId } = selectedExamPreference?.data?.[0] || {};

  React.useEffect(() => {
    if (isAuthenticated) {
      dispatch(fetchExamPreferenceList());
    }
  }, [isAuthenticated]);

  React.useEffect(() => {
    document.addEventListener('mousedown', () => {
      setTimeout(() => {
        setShowID(0);
      }, 3000);
    });
  }, []);

  const handleExamPref = () => {
    setExamPrefModal(true);
  };

  return (
    <>
      {examPrefModal && (
        <div
          className={classNames(examPrefstyles.authModalWrapper, { show: examPrefModal })}
        >
          <div id="auth-modal" className={examPrefstyles.authModal}>
            {examPrefModal && !showLogin && (
              <ExamPreferenceComponent
                examPrefModal={examPrefModal}
                setExamPrefModal={setExamPrefModal}
              />
            )}
          </div>
        </div>
      )}
      <div className={styles.examWrapper}>
        {typeof name !== 'undefined' && (
          <>
            <div className={styles.subHeading}>
              This helps us to provide you a better experience
            </div>
            <div className={styles.examTitle}>
              <div>{name}</div>
              <div
                onClick={() => setShowID(categoryId)}
                className={styles.verticalIcon}
              >
                <FontAwesomeIcon icon={faEllipsisVertical} />
                <div
                  className={classNames(
                  showID === categoryId ? styles.removeBlock : styles.hideElement,
                )}
                  onClick={handleExamPref}
                >
                  Update
                </div>
              </div>
            </div>
          </>
        )}
        {selectedExamPreference?.loading === false &&
          typeof name === 'undefined' && (
            <NotFoundContainer title="No goal is selected">
              <p>
                Select your exam preparing for, This helps us to serve you
                better
              </p>
            </NotFoundContainer>
          )}
        <div className={classNames(styles?.btnWrapper, { [styles?.isGoalSelected]: typeof name === 'undefined' })}>
          <RippleButton
            onClick={handleExamPref}
            className={styles.btnPrimary}
            rippleColor="#fff"
            opacity={0.52}
          >
            {name ? 'Update Your Exam' : 'Add Your Exam'}
          </RippleButton>
        </div>
      </div>
    </>
  );
}

export default MyExam;
